let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kOAvl")).then(() => parcelRequire('7HDKc'));